(function () {
  function bindNav(el, swiper, direction) {
    if (!el) return;
    el.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (direction === 'next') swiper.slideNext();
      else swiper.slidePrev();
    });
  }

  function initCollectionSwipers(root) {
    if (typeof Swiper === 'undefined') return;
    var scope = root || document;
    scope.querySelectorAll('.grid-product .starfire-grid-swiper:not(.swiper-initialized)').forEach(function (swiperEl) {
      var content = swiperEl.closest('.grid-product__content');
      var nextEl = content ? content.querySelector('.starfire-grid-swiper__nav--next') : null;
      var prevEl = content ? content.querySelector('.starfire-grid-swiper__nav--prev') : null;

      var swiper = new Swiper(swiperEl, {
        loop: false,
        nested: true,
        // Image taps must reach the wrapping product <a> — no touch capture.
        allowTouchMove: false,
        preventClicks: false,
        preventClicksPropagation: false,
        autoHeight: false,
        navigation: false,
        observer: true,
        observeParents: true,
      });

      bindNav(nextEl, swiper, 'next');
      bindNav(prevEl, swiper, 'prev');

      // Keep disabled styling in sync (arrows live outside Swiper's nav module).
      function syncDisabled() {
        if (prevEl) prevEl.classList.toggle('is-disabled', swiper.isBeginning);
        if (nextEl) nextEl.classList.toggle('is-disabled', swiper.isEnd);
      }
      syncDisabled();
      swiper.on('slideChange', syncDisabled);
    });
  }

  function observeAjaxGrid() {
    var ajax = document.getElementById('CollectionAjaxContent');
    if (!ajax || ajax.dataset.starfireSwiperObserved) return;
    ajax.dataset.starfireSwiperObserved = 'true';
    new MutationObserver(function () {
      initCollectionSwipers(ajax);
    }).observe(ajax, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCollectionSwipers();
    observeAjaxGrid();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initCollectionSwipers(event.target);
    observeAjaxGrid();
  });
})();
